import { ILemonAction } from '@src/service/business/common/types';
import { createTrackableObject, ITrackableObject } from '@src/service/util/tracking/tracking';

// callback action object type
export type ITrackableAction<T = any> = ILemonAction & ITrackableObject<T>;

/** Enhance action object with event tracker. */
export const createTrackableAction = <T>(action: ILemonAction, trackingParent?: any): ITrackableAction<T> => {
  return createTrackableObject<ILemonAction>(action, trackingParent);
};
